import Gallery from 'components/commercetools-ui/organisms/gallery';
import { UIProduct } from 'components/commercetools-ui/organisms/product/product-details/types';
import Image from 'frontastic/lib/image';
import useClassNames from 'helpers/hooks/useClassNames';
import useCurrentBreakpoint from 'helpers/hooks/useCurrentBreakpoint';
import { FC, memo, useMemo } from 'react';
import { Variant } from 'shared/types/product';
import ProductBadge from '../../badge';

export interface ProductDetailsGalleryProps {
  product: UIProduct;
  variant: Variant;
  inModalVersion?: boolean;
  isTurnOnGallery?: boolean;
  isLazyLoad?: boolean;
}

const ProductDetailsGallery: FC<ProductDetailsGalleryProps> = ({
  product,
  variant,
  inModalVersion,
  isTurnOnGallery,
  isLazyLoad,
}) => {
  const screenSize = useCurrentBreakpoint();
  const isMobileScreen = useMemo(() => {
    return screenSize && ['smallMobile', 'mobile'].includes(screenSize);
  }, [screenSize]);

  const galleryContainerClassName = useClassNames([
    inModalVersion ? 'col-span-6' : 'md:col-span-7 lg:col-span-8',
    'ltr:md:pr-26 ltr:lg:pr-60 h-auto min-h-200 rtl:md:pl-26 rtl:lg:pl-60',
  ]);
  const showGallery = useMemo(() => {
    return !isMobileScreen || (isMobileScreen && isTurnOnGallery);
  }, [isTurnOnGallery, isMobileScreen]);

  const loading = isLazyLoad ? 'lazy' : 'eager';

  return (
    <>
      <div className={galleryContainerClassName}>
        {!variant?.images || !variant?.imagesExtra ? (
          <div className="h-8 animate-pulse rounded bg-gray-200" />
        ) : (
          <>
            {showGallery ? (
              <Gallery
                images={variant?.images ?? []}
                imagesExtra={variant?.imagesExtra ?? []}
                inModalVersion={inModalVersion}
                firstImagePriority={!isLazyLoad}
                hideArrowsOnSingleSlide={true}
                loading={loading}
              >
                <ProductBadge product={product} />
              </Gallery>
            ) : (
              <div className="relative mx-[-24px] min-h-211">
                <Image
                  src={variant?.images?.[0]}
                  style={{ objectFit: 'contain' }}
                  loading={loading}
                  className="relative h-full w-full"
                />
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default memo(ProductDetailsGallery);
